import React from "react";
import { Box, Typography } from "@mui/material";

const EmptyState = ({ icon, message }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        mt: 3,
        color: "#9CA3AF",
      }}
    >
      {icon && (
        <Box sx={{ display: "flex", color: "#9CA3AF" }}>
          {React.cloneElement(icon, { sx: { fontSize: 36, color: "#9CA3AF", ...icon.props?.sx } })}
        </Box>
      )}
      {message && (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "20px",
            color: "#9CA3AF",
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
